import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  AvailableInterventionTimeSlot,
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}TechnicalIntervention/availableTimeSlots`;

interface GetAvailableTimeSlotsQueryPayload {
  fileId: string;
  startDate?: string;
  endDate?: string;
}

const getAvailableTimeSlotsQuery = async ({
  fileId,
  startDate,
  endDate,
}: GetAvailableTimeSlotsQueryPayload): Promise<
  BackResponse<AvailableInterventionTimeSlot[]> | BackResponseFailure
> => {
  const url = buildUrl(ENDPOINT, {
    fileId,
    startDate,
    endDate,
  });

  try {
    return await apiCall<BackResponse<AvailableInterventionTimeSlot[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getAvailableTimeSlotsQuery;
